// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"549":"8d3d349b","703":"afdc7aa3","843":"715cf37e","897":"bb76593d"}[chunkId] + ".chunk.css";
};